<template>
	<div>
		<CHead :oHead="Head">
			
		</CHead>
		<Clist :regresar="true" :ShowBusqueda="false" @FiltrarC="Lista" :pShowBtnAdd="false" :ShowHead="false" :ShowFilas="false" :Filtro="Filtro" :Nombre="NameList" :Pag="Pag" :Total="TotalPagina" :isModal="false" :Cuentas="Cuentas" :pConfigLoad="ConfigLoad">
			<template slot="Filtros">
				<div class="form-group mr-2">
					<v-date-picker
                    mode='range'
                    v-model='Filtro.Fecha'
					@input="Lista">
						<template v-slot="{ inputEvents }">
  						  <input
  						    class="form-control calendar"
  						    :value="$formatRange(Filtro.Fecha)"
  						    v-on="inputEvents"
  						    readonly
  						    placeholder="Selecciona un rango de fecha para buscar"
  						  />
  						</template>
					</v-date-picker>
				</div>
				<label class="mr-2" for="">Departamento</label>
				<select v-model="Filtro.TipoDepartamento" @change="Lista" class="form-control">
					<option value="">Todos</option>
					<option value="1">G&A</option>
					<option value="2">Ventas</option>
					<option value="3">Burden</option>
					<option value="4">MO</option>
				</select>
			</template>
			<template slot="botonCuentas">
				<div class="row">
					<div class="col-lg-10">
						<button type="button"  @click="Nuevo" class="btn btn-primary"><i class="far fa-plus-circle"></i> Crear</button>
					</div>
					<div class="col-lg-2 justify-content-end">
						<h1 class="naranja mr-2">${{sumAmounts}}</h1>
					</div>
				</div>
			</template>
			<template slot="header">
				<tr>
					<th>Fecha</th>
					<th>Departamento</th>
					<th>Cuenta</th>
					<th class="text-center">Sueldo Base</th>
					<th class="text-center">Horas Extra</th>
					<th class="text-center">Comisiones y Bonos</th>
					<th class="text-center">Descuentos</th>
					<th class="text-center">Nomina</th>
					<th class="text-center">Obligaciones de Ley</th>
					<th class="text-center">Beneficios</th>
				</tr>
			</template>
			<template slot="body">
				<tr v-for="(item,index) in Nomina" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.Fecha,false)}}</td>
					<td>{{SetTipoDepartamento(item.TipoDepartamento)}}</td>
					<td>{{SetCuenta(item)}}</td>
					<td class="text-center">{{$formatNumber(item.SueldoBase,'$',false)}}</td>
					<td class="text-center">{{$formatNumber(item.HorasExtra,'$',false)}}</td>
					<td class="text-center">{{$formatNumber(item.Comisiones,'$',false)}}</td>
					<td class="text-center">{{$formatNumber(item.Descuentos,'$',false)}}</td>
					<td class="text-center">{{$formatNumber(item.Total,'$',false)}}</td>
					<td class="text-center">{{$formatNumber(item.Obligaciones,'$',false)}}</td>
					<td class="text-center">{{$formatNumber(item.Beneficios,'$',false)}}</td>
				</tr>
			</template>
		</Clist>
	</div>
</template>

<script>
import CHead from "@/components/CHead";
import Clist from "@/components/Clist.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import CSinRegistros from "@/components/CSinRegistros";
import moment from "moment";

export default {
	name:'nomina',
	components:{CHead,Clist,Cbtnaccion,CSinRegistros},
	data() {
		return {
			NameList: "Nomina",
			TotalPagina: 2,
			Pag: 0,
			Filtro:{
				Nombre: "",
				Placeholder: "Cliente/Factura/Proveedor..",
				TotalItem: 0,
				Pagina: 1,
				Entrada:20,
				TipoDepartamento:'',
				Fecha:{
				}
			},
			Cuentas:{
				isCuentas:true,
				verFiltros:false
			},
			Head: {
				ShowHead: true,
				Title: "Nomina",
				BtnNewShow: false,
				BtnNewName: "Nuevo",
				isreturn: false,
				isModal: false,
				isEmit: true,
				Url: "",
				ObjReturn: "",
				NameReturn: "Regresar",
				isCuentas: false,
				verFiltroCuentas: false
			},
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
			sumAmounts:0,
			Nomina:[]
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader=true;
			await this.$http.get('nominausuario',{
				params:{
					Entrada:this.Filtro.Entrada,
                    pag:this.Filtro.Pagina,
					TipoDepartamento:this.Filtro.TipoDepartamento,
					FechaI:this.Filtro.Fecha.start,
                    FechaF:this.Filtro.Fecha.end,
				}
			}).then((res) => {
				this.Nomina=res.data.data.nominausuario;
				this.sumAmounts=this.numberTo(Number(res.data.data.total));
				this.Filtro.Entrada		= res.data.data.pagination.PageSize;
                this.Filtro.TotalItem	= res.data.data.pagination.TotalItems;
				this.Filtro.Pagina 		= res.data.data.pagination.CurrentPage;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		Nuevo(){
			this.$router.push({name:'nominaform'});
		},
		numberTo(num) {
			//value = value.toFixed(0);
			let fixed = 0;
			if (num === null) {
				return null;
			} // terminate early
			if (num === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = num.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? num.toFixed(0 + fixed)
						: (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
				e = d + ["", " K", " M", " B", " T"][k]; // append power
			return e;
		},
		SetTipoDepartamento(Tipo){
			let Cadena='';
			switch (Tipo) {
				case '1':
					Cadena='G&A';
					break;
				case '2':
					Cadena='Ventas';
					break;
				case '3':
					Cadena='Burden';
					break;
				case '4':
					Cadena='MO';
					break;
				default:
					break;
			}
			return Cadena;
		},
		SetCuenta(Item){
			if (Item.Cuenta == null) {
				return '';
			}
			if (Item.Cuenta=="") {
				return Item.Descripcion;
			}
			else{
				return Item.Cuenta+' - '+Item.Descripcion;
			}
		}
	},
	created() {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        var firstDay = new Date(y, m, 1);
        var lastDay = new Date(y, m + 1, 0);

        this.Filtro.Fecha={
            start:firstDay,
            end:lastDay
        }

		this.Lista();
		this.bus.$off("Delete");
		this.bus.$off("List");
		this.bus.$off("Regresar");
		this.Lista();
		this.bus.$on("Delete", Id => {
			// this.Eliminar(Id);
		});
		this.bus.$on("List", () => {
			this.Lista();
		});
	},
}
</script>

<style>

</style>
